import React from "react";
import { Button, Modal } from "react-bootstrap";

import classNames from "classnames";

import { OrderModalProps } from "@LeagueManagement/Order/types/order";

const CancelOrderModal = ({
    show,
    handleClose,
    handleSubmit,
}: OrderModalProps): React.JSX.Element => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header>
                <Modal.Title className={classNames("text-center")}>
                    Are you show you want to cancel this order?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Cancelling the order will:
                <ul>
                    <li>
                        Cancel <b>all</b> ordered products!
                    </li>
                    <li>Update coupon usage (if applicable)</li>
                    <li>
                        Update the number of open spots in the respective
                        league(s) (if applicable)
                    </li>
                </ul>
                <h6 className="text-center text-danger">
                    Changing the status back after cancelling and saving will
                    not undo the above changes!
                </h6>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => handleSubmit("order", handleClose)}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelOrderModal;
